const getters = {
  lang: state => state.app.lang,
  appInfo: state => state.app.appInfo,
  userInfo: state => state.login.userInfo,
  levelOneList: state => state.nav.levelOneList,
  // 当前客户是否在白名单中
  customerIsInAllowList: state => {
    return state.account.allowList.includes(state.login.userInfo.customerId)
  },
  // 项目运行地址/部署地址
  PROJECT_URL: state => {
    return window.location.origin + state.app.appInfo.APP_BASE_URL
  },
  // 欧美电商结汇内容
  settleData: state => state.settle.settleData,
  step: state => state.settle.step
}

export default getters
